<template>
  <div class="position-relative h-100">
    <b-container>
      <b-row :class="[{ 'fake-hide': tabindexActive !== pageIndex.CONTENT_PAGE }]">
        <b-col cols="12" class="d-flex justify-content-center">
          <div>
            <toolbar-editor
              :class="[
                editorSelectId &&
                editorSelectId !== 'templateBgEditor' &&
                editorSelectId !== 'templateLogoEditor'
                  ? ''
                  : 'fake-hide bypass',
              ]"
              :editor-data="editorData"
              :history-data="historyData"
              :editor-select-id="editorSelectId"
              @onChange="onChangeEditorData"
              @onUndo="onUndoEditorData"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <template-wrap
            :template-id="templateId"
            :template-data="templateData"
            :editor-data="editorData"
            :editor-select-id="editorSelectId"
            :is-active="tabindexActive == pageIndex.CONTENT_PAGE"
            @onSelectEditor="onSelectEditor"
            @onReorder="onReorder"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
} from "@vue/composition-api";
import ToolbarEditor from "@/views/components/toolbar-editor/ToolbarEditor.vue";
import TemplateWrap from "./TemplateWrapper.vue";

import {
  pageIndex
} from "@/configs/privilege/code-template";

export default {
  components: {
    ToolbarEditor,
    TemplateWrap,
  },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
    tabindexActive: { type: Number, default: 0 },
    editorSelectId: null,
    editorData: null,
    historyData: null,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onChangeEditorData = (event) => {
      vm.$nextTick(() => {
        vm.$emit("onChangeEditorData", event);
      });
    };

    const onUndoEditorData = () => {
      vm.$nextTick(() => {
        vm.$emit("onUndoEditorData");
      });
    };

    const onSelectEditor = (event, isRemove) => {
      vm.$nextTick(() => {
        vm.$emit("onSelectEditor", event, isRemove);
      });
    };

    const onReorder = (event) => {
      vm.$nextTick(() => {
        vm.$emit("onReorder", event);
      });
    };

    return {
      onChangeEditorData,
      onSelectEditor,
      onUndoEditorData,
      onReorder,

      pageIndex
    };
  },
};
</script>
